import { CompanyData } from 'components/CompanyView/CompanyData';
import { CompanyDocuments } from 'components/CompanyView/CompanyDocuments';
import { CompanyRHAccess } from 'components/CompanyView/CompanyRHAccess';
import { LinearProgress } from 'components/LinearProgress';
import { DashboardTitle } from 'components/Titles';
import { useCompanies } from 'hooks/useCompanies';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Divider, Grid, Paper, useTheme } from '@mui/material';
import { Button } from 'components';

export const CompanyView: React.FC = () => {
  const { palette } = useTheme();
  const { push } = useHistory();

  const { id } = useParams<{ id: string }>();

  const { getCompany, company, loadingView } = useCompanies();

  useEffect(() => {
    getCompany(id);
  }, [getCompany, id]);

  const handleEdit = () => {
    push(`/admin/dashboard/companies/edit/${id}`);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE EMPRESAS - RESUMO" />
      </Grid>

      <Grid item xs={12}>
        <Paper
          variant="outlined"
          sx={{ border: '2px solid', borderColor: palette.primary.main }}
        >
          {loadingView && <LinearProgress />}

          <CompanyData company={company} />

          <Divider sx={{ mb: 2, borderColor: '#C4C4C4' }} />

          <Grid container spacing={2}>
            <Grid item md={10}>
              <CompanyRHAccess dataRH={company?.users} />
            </Grid>

            <Grid
              item
              xs={2}
              md={2}
              alignSelf="flex-end"
              textAlign="center"
              mb={2}
            >
              <Button sx={{ paddingX: 4 }} onClick={handleEdit}>
                editar
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {company?.documents && (
          <CompanyDocuments
            idCompany={company._id}
            documents={company?.documents}
          />
        )}
      </Grid>
    </Grid>
  );
};
